// extracted by mini-css-extract-plugin
module.exports = {"header":"GetHeader_header__XTIyx","bg":"GetHeader_bg__38bj-","logo":"GetHeader_logo__1PkdK","logoIns":"GetHeader_logoIns__7FO-_","title":"GetHeader_title__2dwh-"};